export const repToUserIDMapping = (reps, filters) => {
  const userIDArr = reps.map(s => filters.reps.filter(r => r.Full_Name === s || r.UserID === s)[0].UserID)
  return userIDArr
}
